import React, { useContext } from "react";
import ColorsMain from "../../../colors/ColorsMain";
import "../../../css/login/login.css";
import ButtonBack from "../../button/ButtonBack";

import { UtilContext } from "../../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../../language/language";


const SuccessRecovery = ({ LoginRequest, ReturnLogin, correo, loading }) => {
  const { language } = useContext(UtilContext); // Usa el contexto de Auth
  return (
    <div
      style={{ color: ColorsMain.texttMain }}
      className="w-3/4 flex justify-evenly flex-col"
    >
      <div className="flex flex-col">
        <p className="text-3xl" style={{ fontFamily: "brico" }}>
          {GLOBAL_LANGUAGE[language].success_recovery.title}
        </p>
        <p className="text-[#B7B7B9] flex mb-8 mt-2 text-[14px]">
          {GLOBAL_LANGUAGE[language].success_recovery.description}
        </p>
        <div className="flex flex-row justify-between mt-4">
          <div className="w-full md:w-auto">
            <ButtonBack
              className="w-full"
              onClick={ReturnLogin}
              label={GLOBAL_LANGUAGE[language].success_recovery.label_button}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessRecovery;
